import { Config } from "../config/Config";
import { StorageConstants } from "../constants/Constants";
import { Routes } from "../constants/RouteConstants";
import moment from "moment";
import CryptoJS from "crypto-js";
import Swal from 'sweetalert2'
import 'moment-timezone';

const ENCODE_SECRET_KEY_1 = '#&*BB&G*&#&*#G8754454^&*T*&GMAN&^#$$ISH883782&**78';
const ENCODE_SECRET_KEY_2 = '!@#$%^&*()UJCFFGS4548MAN/*+5+5as8as7d6t7ISH&^*^&^*';

export const saveToStorage = ({ key, value, type = 'local', isSecure = true }: {
    key: string,
    value: any,
    type?: string,
    isSecure?: boolean
}) => {
    let newValue = JSON.stringify(value);
    if (isSecure) {
        newValue = encodeData(newValue);
    }
    if (type === 'local') {
        localStorage.setItem(key, newValue);
    } else if (type === 'session') {
        sessionStorage.setItem(key, newValue);
    }
};

export const getFromStorage = ({ key, type = 'local', isSecure = true }: {
    key: string,
    type?: string,
    isSecure?: boolean,
}) => {
    let value: any = null;
    if (type === 'local') {
        value = localStorage.getItem(key)
    } else if (type === 'session') {
        value = sessionStorage.getItem(key)
    }
    if (isSecure) {
        value = decodeData(value);
    }
    return isJson(value) ? JSON.parse(value) : value;
};

export const deleteFromStorage = async ({ key, type = 'local' }: {
    key: string,
    type?: string
}) => {
    if (type === 'local') {
        if (key) {
            await localStorage.removeItem(key)
        } else {
            localStorage.clear()
        }
    } else if (type === 'session') {
        if (key) {
            localStorage.removeItem(key)
        } else {
            localStorage.clear()
        }
    }
};

export const getSearchQueryParams = (key: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    const value = searchParams.get(key);
    return value;
}


export const renderFormData = (values: any) => {
    var formData = new FormData();
    Object.keys(values).map(function (key) {
        formData.append(key, values[key])
    });
    return formData
}

export const logoutHelper = () => {

    deleteFromStorage({ key: StorageConstants?.IS_USER_LOGIN_TOKEN });
    deleteFromStorage({ key: StorageConstants?.USER_DETAIL });
    // window.location.href = Config?.url + Routes?.Login;
    // window.location.href = "http://192.168.29.253:3000/fely-beauty-saloon/";

    window.location.href = Config?.BASE_URL + Routes?.Home;
}

export const hideEmail = (email: string) => {
    if (email) {
        const [emailName, emailDomain] = email.split('@');
        const hiddenEmail = '●●●●●●@' + emailDomain;
        return hiddenEmail;

        // const [emailName, emailDomain] = email.split('@');
        // const hiddenLocalPart = emailName.slice(0, emailName?.length > 3 ? 3 : 1);
        // const hiddenEmail = hiddenLocalPart + '***' + '@' + emailDomain;
        // return hiddenEmail;
    }
}




export const appendToArray = ({ array, value, key }: any) => {
    if (key !== undefined) {
        return { ...array, [key]: [...array[key], value] };
    } else {
        return [...array, value];
    }
}
export const removeFromArray = ({ array, value, key }: any) => {
    if (key !== undefined) {
        return { ...array, [key]: array[key].filter((item: any) => item !== value) };
    } else {
        return array.filter((item: any) => item !== value);
    }
}

export const isInArray = ({ array, value }: any) => {
    return array.includes(value);
}



export const appendToKeyInObject = ({ obj, key, value }: any) => {
    obj((prevData: any) => {
        return {
            ...prevData,
            [key]: value
        };
    })
};

export const setDateHelper = ({ date, format = 'MM/DD/YYYY', type }: any) => {
    let formatDate = '';
    if (date && moment(date, format, true).isValid()) {
        formatDate = moment(date).format(format);
    }
    return formatDate;
}
export const getDateHelper = ({ date, format = 'MM/DD/YYYY', type }: any) => {
    let formatDate = '';
    if (date) {
        formatDate = moment(date).format(format);
    }
    return formatDate;
}



export const appendToString = ({ string, value }: any) => {
    return `${string},${value}`.trim();
}

export const removeFromString = ({ string, value }: any) => {
    const stringWithComma = `,${value}`;
    const stringWithoutComma = string.replace(stringWithComma, '');
    return stringWithoutComma.trim();

    // return string.replace(String(value), '').trim();
}

export const encodeData = (value: any) => {
    if (value != null && value != undefined && value != 'undefined') {
        const encryptedData4 = CryptoJS.AES.encrypt(value.toString(), ENCODE_SECRET_KEY_1).toString();
        const encryptedDataMain: any = CryptoJS.AES.encrypt(encryptedData4.toString(), ENCODE_SECRET_KEY_2).toString();
        return encryptedDataMain?.replaceAll("/", "Enc@de");
    } else {
        return value;
    }
}



export const decodeData = (value: any) => {
    if (value != null && value != undefined && value != 'undefined') {
        const replaceddata: any = value?.replaceAll("Enc@de", "/");
        const decryptedData = CryptoJS.AES.decrypt(replaceddata.toString(), ENCODE_SECRET_KEY_2).toString(CryptoJS.enc.Utf8);
        const decryptedData1 = CryptoJS.AES.decrypt(decryptedData.toString(), ENCODE_SECRET_KEY_1).toString(CryptoJS.enc.Utf8);
        return decryptedData1;
    } else {
        return value;
    }
}





// export const showImage = (imagePath: string) => {
//     return Config?.IMAGE_BASE_URL + imagePath
// }

export const pluck = (array: string[] | object[], key: any) => {
    if (array?.length > 0) {
        return array.map((arr: any) => arr[key]);
    } else {
        return array;
    }
}

export const arrayToString = (array: string[] | object[]) => {
    return array.join(',')
}




export const isJson = (str: any) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}



export const getCurrentDateHelper = (format: any = 'MM/DD/YYYY') => {
    let formatDate = moment().format(format);
    return moment(formatDate, format).toDate();
}


export const capitalizeFirstLetter = (str: string) => {
    if (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    else {
        return ""
    }
}



// backspace enter
export const handleBackspaceAndEnter = (e: any, index: any, otpBoxRef: any, numberOfDigits: any) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
        return otpBoxRef.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
        return otpBoxRef.current[index + 1].focus();
    }
}

// paste  

export const getLocationAddress = async ({ type, latitude, longitude }: any) => {
    if (type === 'current') {
        return new Promise((resolve, reject) => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        const geocoder = new window.google.maps.Geocoder();
                        const latLng = new window.google.maps.LatLng(latitude, longitude);
                        geocoder.geocode({ location: latLng }, (results: any, status) => {
                            if (status === 'OK') {
                                if (results[0]) {
                                    resolve({ status: 'SUCCESS', latitude, longitude, address: results[0].formatted_address });
                                } else {
                                    // reject(new Error('No results found'));


                                }
                            } else {
                                // reject(new Error(`Geocoder failed due to: ${status}`));
                            }
                        });
                    },
                    (error: any) => {
                        // reject(new Error('Error getting current location:', error));
                        if (error.code === error.PERMISSION_DENIED) {
                            resolve({ status: 'LOCATION_REJECTED' })
                        } else {
                        }
                    }
                );
            } else {
                // reject(new Error('Geolocation is not supported by this browser.'));

            }
        });
    } else {
        return new Promise((resolve, reject) => {
            const geocoder = new window.google.maps.Geocoder();
            const latLng = new window.google.maps.LatLng(latitude, longitude);
            geocoder.geocode({ location: latLng }, (results: any, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        resolve({ latitude, longitude, address: results[0].formatted_address });
                    } else {
                        reject(new Error('No results found'));
                    }
                } else {
                    reject(new Error(`Geocoder failed due to: ${status}`));
                }
            });
        })
    }
};



export const validImageTypes = ["jpeg", "png", "jpg", "webp", "JPEG", "PNG", "JPG", "WEBP", "image/jpeg", "image/png", "image/jpg", "image/webp", "image/JPEG", "image/PNG", "image/JPG", "image/WEBP"];
// export const validImageTypes = ["jpeg", "png", "JPEG", "PNG", "image/jpeg", "image/png", "image/JPEG",'image/PNG'];


export const capitalizeData = (str: string) => {
    if (typeof str !== 'string') {
        throw new Error('Input must be a string');
    }

    const words = str.split(/\s+/); // Split by whitespace
    const capitalizedWords = words.map(word => {
        if (word.length > 0) {
            // Preserve existing capitalization and lowercase the rest
            return word.charAt(0).toUpperCase() + word.slice(1);
            // return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return '';
    });

    return capitalizedWords.join(' '); // Join capitalized words with single space
};




/** Max size per image for salon profile / staff uploads (must match API multer `fileSize`). */
export const MAX_SALON_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024;

export const validateImage = (file: File, validImageTypes: string[]): string | true => {
    if (file) {
        const fileType = file?.type?.toLowerCase();
        const extension = file?.name?.split('.').pop()?.toLowerCase();

        // Check file type or extension
        if ((!fileType && !validImageTypes.includes(`image/${extension}`)) ||
            (fileType && !validImageTypes.includes(fileType))) {
            return "File format does not support";
        }

        if (file?.size > MAX_SALON_IMAGE_UPLOAD_BYTES) {
            return "Image size must be 5 MB or smaller";
        }
    }
    return true;
};

// export const validateImage = (file: any, validImageTypes: any) => {
//     if (file) {
//         const fileType = file.type ? file.type.toLowerCase() : '';
//         const extension = file.name.split('.').pop()?.toLowerCase();

//         // Check file type or extension
//         if (!fileType && !validImageTypes.includes(`image/${extension}`)) {
//             // toast.error("File format does not support");
//             return "File format does not support";
//         } else if (fileType && !validImageTypes.includes(fileType)) {
//             // toast.error("File format does not support");
//             return "File format does not support";
//         }

//         if (file.size > MAX_SALON_IMAGE_UPLOAD_BYTES) {
//             return "Image size must be 5 MB or smaller";
//         }
//     }
//     return true;
// };


export const handleShowSwalConfirmation = (msg: any = null, showCancel = false, showTitle = true, title: any) => {
    return new Promise((resolve) => {
        Swal.fire({
            // let confirmation = await handleShowSwalConfirmation(intl.formatMessage({ id: 'delete_pop_up' }), true);

            title: showTitle ? title : "Are you sure",
            text: msg ? msg : "Do you want to delete.",
            icon: 'warning',
            showDenyButton: showCancel,
            confirmButtonColor: '#31CE36',
            confirmButtonText: showCancel ? 'Yes' : 'Ok',
            allowOutsideClick: false,
            // closeable: true
        }).then((result: any) => {
            resolve(result.isConfirmed);
        });
    });

}



export const options = {
    loop: true, margin: 10, nav: false, dots: false, autoplay: true,
    autoplayTimeout: 5000, autoplayHoverPause: false, responsive: {
        0: {
            items: 2,
            center: true
        },
        600: {
            items: 4
        },
        1000: {
            items: 5
        },
        1600: {
            items: 6
        }
    }
};

export const handleInput = (event: any) => {
    let value = event.target.value.replace(/[^0-9]/g, ''); // Allow only numbers

    // Remove leading zeros
    if (value.length > 1 && value.startsWith('0')) {
        value = value.replace(/^0+/, '');
    }

    // Ensure the value does not exceed 5 digits
    if (value.length > 5) {
        value = value.slice(0, 5);
    }

    // Set the input value
    event.target.value = value;
};

export const setDateFormatData = (date: any) => {
    let formatDate = '';
    if (date && moment(date, 'YYYY/MM/DD', true).isValid()) {
        formatDate = moment(date).format('YYYY/MM/DD');
    }
    return formatDate;
}

export const getDateFromat = (date: any) => {
    return date ? moment(date).format('YYYY-MM-DD') : '';
}



export const setDateFormat = (date: any) => {
    let formatDate = '';
    if (date && moment(date, 'YYYY-MM-DD', true).isValid()) {
        formatDate = moment(date).format('YYYY-MM-DD');
    }
    return formatDate;
}


const secretKey4 = 'O@RcQfTjWnZr4-PaiOwnER-KaNdRgUkX';
const secretKey5 = 'O@RcQChillINg-PaiOwnER-KaNdRgUkX';

export const encodeID = (id: any) => {
    if (id != null) {
        const encryptedData4 = CryptoJS.AES.encrypt(id.toString(), secretKey4).toString();
        const encryptedDataMain: any = CryptoJS.AES.encrypt(encryptedData4.toString(), secretKey5).toString();
        return encryptedDataMain?.replaceAll("/", "Pai");
    } else {
        return id;
    }
    
}

export const decodeID = (id: any) => {
    
    if (id != null) {
        const replaceddata: any = id?.replaceAll("Pai", "/");
        const decryptedData = CryptoJS.AES.decrypt(replaceddata.toString(), secretKey5).toString(CryptoJS.enc.Utf8);
        const decryptedData1 = CryptoJS.AES.decrypt(decryptedData.toString(), secretKey4).toString(CryptoJS.enc.Utf8);
        return decryptedData1;
    } else {
        return id;
    }
}



// Last Url location 
export const getLastURL = (location: any) => {
    let lastURL = location && location.pathname && location.pathname.split('/') && location.pathname.split('/').pop();
    return lastURL;
}



export const dateFormat = (date: any) => {
    moment.locale('en');
    const formattedDate = moment(date).format('ddd, MMM DD, YYYY');
    return formattedDate;
}

// "2024-06-12T09:54:07.000Z";

export const getTimeHelper = ({ time, format = 'HH:mm' }: any) => {
    if (!time) return null;
    return moment(time, format).toDate();
};

export const setTimeHelper = ({ time, format = 'HH:mm' }: any) => {
    if (!time) return '';
    return moment(time).format(format);
};



// Helper function to format time
export const formatTime = (date: string) => {
    const formattedDate = moment(new Date(date)).format('HH:mm');
    return formattedDate;
}



// Helper function to format time
// export const formatTime = (timeString: any) => {
//     // Check if timeString is a string
//     if (typeof timeString !== 'string') {
//         console.error('Invalid input type:', typeof timeString);
//         return null;
//     }

//     // Parse timeString with strict parsing
//     const formattedTime = moment(timeString, 'HH:mm', true);

//     // Check if parsed time is valid
//     if (formattedTime.isValid()) {
//         // Format to 'YYYY-MM-DDTHH:mm:ss'
//         return formattedTime.format('YYYY-MM-DDTHH:mm:ss');
//     } else {
//         console.error('Invalid time format:', timeString);
//         return null; // Or handle the error as per your application's needs
//     }
// };


export const ArraySortByIndex = (array: any) => {
    const indexValuePairs = array.map((value: any, index: any) => ({ index, value }));
    indexValuePairs.sort((a: any, b: any) => b.index - a.index);
    const sortedArray = indexValuePairs.map((pair: any) => pair.value);
    return sortedArray;
};


export const YearSelection = () => {
    const startYear = 2024;
    const endYear = 2050;
    const yearData = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    return yearData;
};


export const PastYearSelection = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5; // 5 years ago
    const endYear = currentYear;
    const yearData = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    return yearData;
};



const daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
// export const generateDateList = () => {
//     const dates = [];
//     for (let i = 1; i <= 31; i++) {
//         const dayIndex = (i - 1) % 7;
//         dates.push({ day: daysOfWeek[dayIndex], date: i });
//     }
//     return dates;
// };
export const generateDateList = () => {
    const dates = [];
    const currentMonth = moment().month(); // 0-11 (January is 0, December is 11)
    const currentYear = moment().year();
    const daysInMonth = moment().daysInMonth(); // Get the number of days in the current month

    for (let i = 1; i <= daysInMonth; i++) {
        const date = moment([currentYear, currentMonth, i]); // Create a date for each day in the current month
        const dayIndex = date.day(); // Get the day of the week (0-6)
        dates.push({ day: daysOfWeek[dayIndex], date: i });
    }

    return dates;
};


export const createdAtFormat = (date: any) => {
    if (date) {
        const formattedDate = moment(date).format("D MMM YYYY");
        return formattedDate;
    } else {
        return ""
    }
}


// export const monthYear = () => {
//     const datea = new Date();
//     const options: any = { month: 'long', year: 'numeric' };
//     const currentMonthYear = datea.toLocaleDateString('en-US', options);
//     return currentMonthYear;
// }

export const monthYear = (month: any) => {
    const currentYear = new Date().getFullYear();
    const date = new Date(`${currentYear}-${month}-01`);
    const options: any = { month: 'long', year: 'numeric' };
    const currentMonthYear = date.toLocaleDateString('en-US', options);
    return currentMonthYear;
}



export const formatSelectedDate = (year: any, month: any, day: any) => {
    const getMonthNumber = (monthName: any) => {
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return monthNames.indexOf(monthName) + 1;
    }

    const monthNumber = typeof month === 'string' ? getMonthNumber(month) : month;

    const formattedMonth = String(monthNumber).padStart(2, '0');
    const formattedDay = String(day).padStart(2, '0');

    return `${year}-${formattedMonth}-${formattedDay}`;
}


// export const compareSelectedDate = (givenDate: any) => {
//     const today = new Date();
//     const parseDate = (dateStr: any) => {
//         const [year, month, day] = dateStr.split('-');
//         return new Date(year, month - 1, day); // Month is 0-indexed
//     }

//     const dateObj = parseDate(givenDate);

//     return today > dateObj;
// }


export const compareSelectedDate = (givenDate: any) => {
    const today = new Date();

    const parseDate = (dateStr: any) => {
        if (dateStr) {
            const [year, month, day] = dateStr?.split('-');
            return new Date(year, month - 1, day); // Month is 0-indexed

        }

        return dateStr
    }

    const dateObj = parseDate(givenDate);


    return today > dateObj;
}




export const isFutureDate = ( booking_time: any) => {

    let bookingTime = moment.utc(booking_time).local().format("YYYY-MM-DDTHH:mm:ss");

    const now = new Date();
    let todayDate = moment.utc(now).format("YYYY-MM-DDTHH:mm:ss")

    if(bookingTime > todayDate){
        return true
    }
    return;
}


export const FormatTimeDate = (time: string) => {
    if (time) {
        // Create a Date object with the provided time
        const [hours, minutes, seconds] = time.split(':').map(Number);
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(seconds || 0); // Handle the case where seconds might be omitted

        // Format the time based on the user's locale
        const options: Intl.DateTimeFormatOptions = {
            hour: 'numeric',
            minute: 'numeric',
        };

        return new Intl.DateTimeFormat(undefined, options).format(date);
    }
    return;
};

export const LocalFormat = (time: any) => {
    if (time) {
        moment.locale('en');
        // let formattedDate = moment.utc(time).local().format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)');
        let formattedDate = moment.utc(time).local().format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)');
        return formattedDate;
    }
    return;
}
export const LocalTimeFormat = (time: any) => {
    if (time) {
        moment.locale('en');
        // let formattedDate = moment.utc(time).local().format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)');
        let formattedDate = moment.utc(time).local().format('hh:mm');
        return formattedDate;
    }
    return;
}

/** API stores time as HH:mm or HH:mm:ss (UTC). */
export const normalizeTimeForUtcParse = (t: string) => {
    const parts = String(t).trim().split(":");
    const h = String(Math.min(23, Math.max(0, parseInt(parts[0], 10) || 0))).padStart(2, "0");
    const m = String(Math.min(59, Math.max(0, parseInt(parts[1], 10) || 0))).padStart(2, "0");
    const s =
        parts.length > 2
            ? String(Math.min(59, Math.max(0, parseInt(parts[2], 10) || 0))).padStart(2, "0")
            : "00";
    return `${h}:${m}:${s}`;
};

/** Stored UTC calendar date + UTC time → local calendar date (YYYY/MM/DD) + Date for time picker. */
export const utcStoredToLocalDateAndTime = (apiDate: string, apiTime: string) => {
    if (!apiDate || !apiTime) return null;
    const day = moment(apiDate).format("YYYY-MM-DD");
    const hm = normalizeTimeForUtcParse(apiTime);
    const m = moment.utc(`${day} ${hm}`, "YYYY-MM-DD HH:mm:ss").local();
    if (!m.isValid()) return null;
    return { dateStr: m.format("YYYY/MM/DD"), timeDate: m.toDate() };
};

/** Local calendar date + time picker value → UTC YYYY-MM-DD and HH:mm for API. */
export const localFormToUtcDateAndTime = (dateInput: any, timeDate: any) => {
    if (!dateInput || !timeDate) return null;
    let m = moment(dateInput, ["YYYY/MM/DD", "YYYY-MM-DD"], true);
    if (!m.isValid()) m = moment(dateInput);
    if (!m.isValid()) return null;
    m = m
        .hour(moment(timeDate).hour())
        .minute(moment(timeDate).minute())
        .second(0)
        .millisecond(0);
    return { date: m.utc().format("YYYY-MM-DD"), time: m.utc().format("HH:mm") };
};

/**
 * Fixed ISO-week reference dates (1970-01-05 = Monday) for recurring weekday hours:
 * local time on that anchor ↔ UTC HH:mm without a real calendar date on the form.
 */
export const WEEKDAY_UTC_ANCHOR: Record<string, string> = {
    Monday: "1970-01-05",
    Tuesday: "1970-01-06",
    Wednesday: "1970-01-07",
    Thursday: "1970-01-08",
    Friday: "1970-01-09",
    Saturday: "1970-01-10",
    Sunday: "1970-01-11",
};

export const UTCFormat = (time: any) => {
    
    if (time) {
        let bookingTime = moment.utc(time).format("YYYY-MM-DDTHH:mm:ss");
        let formatDate = moment(bookingTime).format("HH:mm");
        return formatDate
    }
    return;
}

export const FormatTime = (time: string) => {
    
    if(time){
        const [hours, minutes] = time.split(':').map(Number);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert to 12-hour format
        return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

    }
    return
};

// export const UtcDate = (data: any) => {
//     const utcDate = moment.utc(data).format("YYYY-MM-DDTHH:mm:ss");

//     // Convert to Date object and log it
//     const bookingDateTime = new Date(utcDate);

//     // Manually format the date to remove the ".000Z"
//     const formattedDateTime = utcDate.replace('Z', '');

//     return formattedDateTime;
// }

// export const UtcDate = (data: any) => {
//     const utcDate = moment.utc(data).format("YYYY-MM-DDTHH:mm:ss");

//     // Convert to Date object and log it
//     const bookingDateTime = new Date(utcDate);

//     // Manually format the date to remove the ".000Z"
//     const formattedDateTime = utcDate.replace('Z', '');

//     return formattedDateTime;
// }

export const UtcDate = (): string => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
};

// export const UtcDate = (data: any) => {
//     const utcDate = moment.utc(data).format("YYYY-MM-DDTHH:mm:ss");
//     const bookingDateTime = new Date(utcDate);
//     return bookingDateTime
// }

export const getTimeZoneToUtc = async (datetime: string, datetime_format: any, timezone: string) => {
    const get_datetime = await moment.tz(`${datetime}, ${datetime_format}`, timezone).utc().format(Config?.DATE_TIME_FORMATE)
    return get_datetime;
};




// export const UTC = (payload:any)=>{
//    let time = moment.utc(payload).local().format("h:mm A, MMM DD, Y")
//    return time;
// }

// export const isFutureDate = (bookingDate: any, bookingTime: any) => {
//     if (bookingDate && bookingTime) {
//         const bookingDateTimeString = `${bookingDate}T${bookingTime}`;
//         const bookingDateTime = new Date(bookingDateTimeString);
//         const now = new Date();
//         return bookingDateTime > now;

//     }
//     return;
// }


export const extractTimeFromDate = (date: Date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    return formattedTime;
};



export const sidebarOpen = () => {
    $(".leftsidebar").addClass("active")
}


export const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};



export const monthName = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]


export const timeAgo = (date: any) => {
    return moment(date).fromNow();
};


export const localTimezone = (date: any) => {
    if (date) {
        // Parse the date as UTC and convert to local timezone
        const localDate = moment.utc(date).local();
        return localDate.fromNow();
    }
    return;
}

// export const localTimezone = (date: any) => {
//     if (date) {
//         let utcDate = new Date(date).toLocaleString()
//         console.log('date = ',moment(utcDate).fromNow())
//         // moment(utcDate).fromNow()
//         // return moment(utcDate).fromNow()
//         return moment(utcDate).fromNow()
//     }
//     return;

// }


export const monthMap: { [key: string]: string } = {
    January: '01',
    February: '02',
    March: '03',
    April: '04',
    May: '05',
    June: '06',
    July: '07',
    August: '08',
    September: '09',
    October: '10',
    November: '11',
    December: '12'
};

export const getMonthNumber = (monthName: string | number): string | null => {
    if (monthName === '' || monthName == null) {
        return null;
    }

    // Already numeric (e.g. 8, "8", "08")
    if (typeof monthName === 'number' || /^\d{1,2}$/.test(String(monthName).trim())) {
        const n = Number(monthName);
        if (n >= 1 && n <= 12) {
            return String(n).padStart(2, '0');
        }
        return null;
    }

    const key = String(monthName).trim();
    const matched =
        monthMap[key] ||
        monthMap[key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()];

    return matched || null;
}

export const formatTimeMinutes = (value: any) => {
    const numericValue = parseFloat(value);

    if (numericValue < 1) {
        return `${numericValue} Mins`;
    } else {
        // Use the value directly as hours
        return `${numericValue} Hours`;
    }
}


export const getAgeFromDOB = (dobString:any) =>{
    const today = new Date();
    const dob = new Date(dobString);

    let age = today.getFullYear() - dob.getFullYear();

    // check if birthday passed this year
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    return age;
}

 
